const t=()=>({root:["bp-StatLabel",{display:"flex"}],label:{},button:{marginLeft:24}});export{t as getStatLabelStyles};
//# sourceMappingURL=StatLabel.styles.js.map
